import * as React                          from 'react'
import { connect }                         from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router'

import { bindActionCreators } from 'redux'

import { AccountType }                  from '../../api'
import {
  communicationThrewError,
  communicationWasSuccessful,
}                                       from '../../project-utils'
import {
  ApplicationState,
  genRegisterRequest,
  queueToast,
  selectAuthState,
}                                       from '../../redux'
import { FormStep, RegistrationWizard } from './'

interface RegistrationProps {
  steps: FormStep []
  accountType: AccountType
}

const mstp = (state: ApplicationState, { accountType }: RegistrationProps) => ({
  communication:  genRegisterRequest(accountType).communicationSelector(state),
  authentication: selectAuthState(state),
})

const mdtp = (dispatch, { accountType }: RegistrationProps) => {
  return bindActionCreators(
    {
      queueToast,
      register: genRegisterRequest(accountType).actionCreator,
    },
    dispatch,
  )
}

type OwnProps =
  RegistrationProps
  & RouteComponentProps<{ token: string }>

type Props =
  OwnProps
  & ReturnType<typeof mstp>
  & ReturnType<typeof mdtp>

class Registration extends React.Component<Props> {
  public componentDidUpdate ({ communication: lastCommunication }) {
    const { communication, queueToast } = this.props

    if (communicationWasSuccessful(lastCommunication, communication)) {
      this.props.history.replace('/')
    }

    if (communicationThrewError(lastCommunication, communication)) {
      queueToast({
        withoutI18nPrefix: true,
        error:             true,
        message:           String(communication.error),
      })
    }
  }

  public render () {
    const {
      steps,
      communication: { fetching },
    } = this.props

    return (
      <RegistrationWizard
        isSubmitting={fetching}
        steps={steps}
        done={this.done}
      />
    )
  }

  private done = values => {
    const { register, match } = this.props

    register({ ...values, token: match.params.token })
  }
}

export default connect(mstp, mdtp)(withRouter(Registration))



// WEBPACK FOOTER //
// ./src/components/organisms/Registration.tsx